import React from 'react';
import { LIST_TYPE } from 'eventbrite_design_system/mediaCardContent/constants';
import SearchEventCardStyleSwitcher from '../SearchEventCardStyleSwitcher';
import SeeMoreButton from '../SeeMoreButton';

import { GA_VIEW_MORE_ACTION } from '../../constants';

const ListCardGroup = ({
    cards,
    linkUrl,
    title,
    onSaveEvent,
    shareOptions,
    isAuthenticated,
    onTrackClick,
    onTrackClickInternal,
    trackGAEvent,
    featureFlags,
    userCollections,
    onAddOrRemoveEventToCollection,
    onCreateCollection,
}) => (
    <div>
        <ul className="search-main-content__events-list">
            {cards.map(({ id, ...cardProps }, index) => (
                <li key={id}>
                    <SearchEventCardStyleSwitcher
                        id={id}
                        trackClick={onTrackClick.bind(null, index, id)}
                        type={LIST_TYPE}
                        shareOptions={shareOptions}
                        isAuthenticated={isAuthenticated}
                        onSaveEvent={onSaveEvent}
                        containerSpacingClasses="eds-l-pad-all-4"
                        trackClickInternal={onTrackClickInternal.bind(
                            null,
                            index,
                        )}
                        trackGAEvent={trackGAEvent}
                        featureFlags={featureFlags}
                        userCollections={userCollections}
                        onAddOrRemoveEventToCollection={
                            onAddOrRemoveEventToCollection
                        }
                        onCreateCollection={onCreateCollection}
                        {...cardProps}
                    />
                </li>
            ))}
        </ul>
        <div className="eds-show-down-sn eds-align--center eds-l-pad-top-6">
            <SeeMoreButton
                linkUrl={linkUrl}
                trackClick={onTrackClick}
                title={title}
                gaAction={GA_VIEW_MORE_ACTION}
                size="block"
            />
        </div>
    </div>
);

export default ListCardGroup;
